import { render, staticRenderFns } from "./contentPricingGroup.vue?vue&type=template&id=04391f55&"
import script from "./contentPricingGroup.vue?vue&type=script&lang=js&"
export * from "./contentPricingGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports